import { AlignmentType, HeadingLevel, Paragraph, TabStopType, TextRun } from "docx";

export const heading1 = new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400, },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Introduction",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})


export const heading2 = new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Engagement Scope",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})

export const heading3 = new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Details of the Auditing team",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})

export const heading4 = new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Audit Activities and Timelines",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})

export const heading5 = new Paragraph({

    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Audit Methodology and Criteria / Standard referred for audit",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})

export const heading6 = new Paragraph({

    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Tools/ Software used",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})


export const heading7 = new Paragraph({

    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Executive Summary",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})


export const heading8 = new Paragraph({

    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Detailed Observation",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})

export const heading9 = new Paragraph({

    alignment: AlignmentType.CENTER,
    spacing: { before: 350, after: 400 },
    indent: { left: 600 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Appendices",
            size: 40,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_1,
})